import { FolderOpen } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import type { PanelWidth } from '@/types/panels';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'case_details',
    title: 'Case',
    icon: FolderOpen,
    // Wide enough for the tabs to read, narrow enough to leave the video
    // surface beside it the width a scene of cameras needs.
    width: { min: 320, default: 420, max: 720, fill: false },
    // A case with nothing to show beside it has the stage to itself.
    getWidth: (_props, row): Partial<PanelWidth> | undefined => (
        row.some((openPanel) => openPanel.id !== 'case_details' && openPanel.config.width?.fill)
            ? undefined
            : { max: Infinity, fill: true }
    ),
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    // The case's own header carries its name and the way back to the list, so
    // the generic chrome would stack a second title above it.
    isHeaderless: true,
    order: 4.6,
    // Opened from a case in the list, never from the rail.
    hasNavButton: false,
});
